import React, { Fragment } from 'react'
import styled from 'styled-components'

const ApiTitle = ({ attributes, children, element, editor }) => <Title {...attributes}>{children}</Title>

export default ApiTitle

const Title = styled.div`
  flex: 1;
  color: ${props => props.theme.textGreyTintedDarker};
  font-weight: bold;
`
